import { useContext } from 'react'
import { ExpedientesContext } from '../providers/ExpedientesProvider'
import ListaExpedientes from './ListaExpedientes'

import { Box } from '@mui/material'

export default function ListadoExpedientes() {
  const {
    active: { current },
    altaExpediente,
  } = useContext(ExpedientesContext)

  return (
    <Box sx={{ width: '100%' }}>
      {current && !altaExpediente ? <ListaExpedientes tipo={current.tipo_expediente} /> : <></>}
    </Box>
  )
}
